import React from 'react';
import { Box, Paper, Typography } from '@mui/material';
import { useTokens } from 'theme';

/** A titled card of the "Загрузки" / "Источник" screens. */
export default function Section({ title, aside, children, sx }) {
  const t = useTokens();
  return (
    <Paper sx={{ p: 2, ...sx }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', gap: 1, mb: 1.25 }}>
        <Typography sx={{ fontWeight: 700, fontSize: '0.9rem' }}>{title}</Typography>
        {aside && (
          <Typography component="div" sx={{ fontSize: '0.8rem', color: t.inkMuted }}>{aside}</Typography>
        )}
      </Box>
      {children}
    </Paper>
  );
}

/** A label on the left, its value on the right. */
export function Row({ label, children }) {
  const t = useTokens();
  return (
    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', gap: 2, py: 0.5 }}>
      <Typography sx={{ fontSize: '0.85rem', color: t.inkMuted, flexShrink: 0 }}>{label}</Typography>
      <Typography component="div" sx={{ fontSize: '0.85rem', textAlign: 'right', minWidth: 0, overflowWrap: 'anywhere' }}>
        {children}
      </Typography>
    </Box>
  );
}
